export const filterCompanies = (data, regexp) => {
  return data.filter((company) => {
    return regexp.test(company?.companyName);
  });
};
